import * as React from 'react';
type IconComparadorSuccesProps = React.SVGProps<SVGSVGElement>;

export const IconComparadorSucces: React.FC<IconComparadorSuccesProps> = (props) => (
	<svg
		width="52"
		height="46"
		viewBox="0 0 52 46"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<mask
			id="mask0_1646_25672"
			maskUnits="userSpaceOnUse"
			x="0"
			y="8"
			width="37"
			height="38">
			<circle
				cx="18.4627"
				cy="27.3875"
				r="18.388"
				fill="white"
			/>
		</mask>
		<g mask="url(#mask0_1646_25672)">
			<circle
				cx="18.4627"
				cy="27.3875"
				r="18.388"
				fill="#8BA293"
			/>
			<g clipPath="url(#clip0_1646_25672)">
				<path
					d="M20.8886 34.7424C31.3052 31.5752 34.3731 43.9364 39.8895 28.0002C40.3798 17.2125 31.9214 11.6553 27.6309 10.2251C24.9748 12.6768 18.6821 17.7029 14.7593 18.1932C9.85582 18.8062 15.3722 26.7743 10.4687 28.6131C5.56527 30.4519 9.24289 38.2833 20.8886 34.7424Z"
					fill="#EFF4F1"
				/>
				<path
					d="M17.211 40.2588C8.38479 36.8264 3.72649 38.42 1.8877 40.2588C14.1464 50.5561 26.6093 46.1838 31.3085 42.7105C30.6955 42.9149 26.0373 43.6912 17.211 40.2588Z"
					fill="#EFF4F1"
				/>
			</g>
		</g>
		<circle
			cx="30.416"
			cy="15.1401"
			r="14.916"
			fill="#FFA692"
		/>
		<circle
			cx="30.4618"
			cy="14.891"
			r="11.9842"
			fill="#EFF4F1"
		/>
		<path
			d="M38.8511 26.1733L40.5459 24.4785L51.0781 35.0107C51.5461 35.4787 51.5461 36.2375 51.0781 36.7055C50.6101 37.1736 49.8513 37.1736 49.3833 36.7055L38.8511 26.1733Z"
			fill="#FFA692"
		/>
		<path
			d="M24.6451 17.33C24.3062 17.33 24.0195 17.2257 23.7849 17.0172C23.5633 16.7956 23.4525 16.5219 23.4525 16.1961C23.4525 15.8702 23.5633 15.603 23.7849 15.3945C24.0195 15.186 24.3062 15.0817 24.6451 15.0817H30.5883C30.9272 15.0817 31.2074 15.186 31.4289 15.3945C31.6636 15.603 31.7809 15.8702 31.7809 16.1961C31.7809 16.5219 31.6636 16.7956 31.4289 17.0172C31.2074 17.2257 30.9272 17.33 30.5883 17.33H24.6451ZM24.6451 14.3584C24.3062 14.3584 24.0195 14.2541 23.7849 14.0455C23.5633 13.824 23.4525 13.5503 23.4525 13.2244C23.4525 12.8986 23.5633 12.6314 23.7849 12.4229C24.0195 12.2144 24.3062 12.1101 24.6451 12.1101H30.5883C30.9272 12.1101 31.2074 12.2144 31.4289 12.4229C31.6636 12.6314 31.7809 12.8986 31.7809 13.2244C31.7809 13.5503 31.6636 13.824 31.4289 14.0455C31.2074 14.2541 30.9272 14.3584 30.5883 14.3584H24.6451ZM31.8004 21.6896C30.9141 21.6896 30.0735 21.5398 29.2784 21.24C28.4834 20.9402 27.7731 20.4971 27.1475 19.9106C26.5349 19.3241 26.0462 18.5942 25.6812 17.721C25.3293 16.8347 25.1534 15.8116 25.1534 14.6516C25.1534 13.648 25.3163 12.7227 25.6421 11.8755C25.968 11.0283 26.4306 10.2984 27.0302 9.68587C27.6297 9.06027 28.3335 8.57803 29.1416 8.23917C29.9497 7.88726 30.8359 7.71131 31.8004 7.71131C32.2957 7.71131 32.7844 7.77648 33.2667 7.90681C33.7619 8.03715 34.2181 8.22613 34.6352 8.47377C34.974 8.6432 35.1695 8.91039 35.2217 9.27532C35.2868 9.64026 35.1956 9.97261 34.948 10.2724C34.7785 10.507 34.557 10.6373 34.2833 10.6634C34.0226 10.6894 33.7554 10.6373 33.4817 10.507C33.2341 10.3636 32.9669 10.2528 32.6802 10.1746C32.3934 10.0964 32.1002 10.0573 31.8004 10.0573C30.9532 10.0573 30.2038 10.2528 29.5521 10.6438C28.9005 11.0348 28.3922 11.5757 28.0272 12.2665C27.6753 12.9442 27.4994 13.7393 27.4994 14.6516C27.4994 15.7073 27.6884 16.5871 28.0663 17.2909C28.4573 17.9816 28.9787 18.4965 29.6303 18.8353C30.282 19.1742 31.0054 19.3436 31.8004 19.3436C32.1002 19.3436 32.3869 19.311 32.6606 19.2459C32.9473 19.1807 33.221 19.0634 33.4817 18.894C33.7554 18.7636 34.0226 18.718 34.2833 18.7571C34.557 18.7962 34.7851 18.9331 34.9675 19.1677C35.2282 19.4935 35.3194 19.8324 35.2412 20.1843C35.1761 20.5232 34.9806 20.7708 34.6547 20.9272C34.355 21.0966 34.0487 21.24 33.7359 21.3573C33.4231 21.4616 33.1037 21.5398 32.7779 21.5919C32.4651 21.6571 32.1393 21.6896 31.8004 21.6896Z"
			fill="#8BA293"
		/>
		<defs>
			<clipPath id="clip0_1646_25672">
				<rect
					width="34.3242"
					height="36.776"
					fill="white"
					transform="translate(3.75244 8.99951)"
				/>
			</clipPath>
		</defs>
	</svg>
);
export default IconComparadorSucces;
